import { AccountUser } from '../features/account/types';
import { TFunction } from 'i18next';
import { parseLocalDate } from './general';

const userInfoToAccountDetailsForm = (userInfo: AccountUser | null, t: TFunction) => {
  const address = userInfo?.address[0];

  const getCountryValue = (countryCode: string | undefined) => {
    if (countryCode === 'US') {
      return { value: 'US', label: t('United States') };
    }
    return countryCode ? { value: countryCode, label: t(countryCode) } : { value: '', label: '' };
  };
  return {
    email: userInfo?.telecom.find((item: any) => item.system === 'email')?.value,
    phone: userInfo?.telecom.find((item: any) => item.system === 'phone')?.value,
    firstName: userInfo?.name?.[0]?.given?.[0] ?? '',
    middleName: userInfo?.name[0]?.given?.[1] ?? '',
    lastName: userInfo?.name[0]?.family || '',
    birthdate: userInfo?.birthDate
      ? typeof userInfo.birthDate === 'string'
        ? parseLocalDate(userInfo.birthDate)
        : // If it's already a Date, reconstruct it as a local date to avoid timezone issues
          new Date(
            userInfo.birthDate.getFullYear(),
            userInfo.birthDate.getMonth(),
            userInfo.birthDate.getDate(),
          )
      : new Date(),
    sex: userInfo?.gender
      ? {
          value: userInfo.gender,
          label: t(userInfo.gender.charAt(0).toUpperCase() + userInfo.gender.slice(1)),
        }
      : { value: '', label: '' },
    street: address?.line[0] || '',
    unit: address?.line[1] || '',
    city: address?.city || '',
    state: address?.state
      ? { value: address.state, label: t(address.state) }
      : { value: '', label: '' },
    zip: address?.postalCode || '',
    country: getCountryValue(address?.country),

    avatar: userInfo?.avatar ? userInfo?.avatar[0] : null,
  };
};

export default userInfoToAccountDetailsForm;
